// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__21VZG","expandIconWrapper":"CustomNode_expandIconWrapper__39RBL","isOpen":"CustomNode_isOpen__3VOEP","labelGridItem":"CustomNode_labelGridItem__1Ew_B"};